import React from "react";
import { Grid, Typography, Paper } from "@mui/material";
import b2 from "../images/cover2.jpg";
import SectionWrapper from "./SectionWrapper";

const title = "BÅ Allservice";
const subtitle = "Staffanstorp";
const bread: string[] = [
  "Utför tjänster till företagare och privatpersoner",
  "Inget uppdrag är för litet",
];

const Hero: React.FC = () => {
  return (
    <SectionWrapper name="home" bg={b2} minHeight="90vh">
      <Grid container spacing={{ xs: 2, sm: 4 }} borderRadius={3} sx={{ mt: { xs: 8, sm: 10, md: 12 } }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 }, width: "100%" }}>
            <Typography
              variant="h1"
              component="div"
              fontWeight={12}
              gutterBottom
              sx={{ fontSize: { xs: "1.75rem", sm: "2.5rem", md: "3rem" } }}
            >
              {title}
            </Typography>
            <Typography
              variant="h3"
              component="div"
              fontWeight={12}
              gutterBottom
              sx={{ fontSize: { xs: "1.25rem", sm: "1.75rem", md: "2rem" } }}
            >
              {subtitle}
            </Typography>
            <Typography variant="subtitle1" sx={{ my: 2, fontSize: { xs: "0.9rem", sm: "1rem" } }}>
              <>
                {bread.map((line, i) => (
                  <div key={i} style={{ marginBottom: "0.5rem", fontWeight: i == 1 ? "bold": "normal"}}>{line}</div>
                ))}
              </>
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </SectionWrapper>
  );
};

export default Hero;
